import { paveSchema } from "../common/schemaUtil";
export function getListProps() {
  // const { body, query } = this.collection.getUsedRequestParamsMap('list');
  // sort 在query里面有sort order， order是可选的
  // return ['page', 'size', 'include', 'exclude', 'filter', 'sort'].filter((name) => body[name] || query[name]);
  return ['page', 'size', 'include', 'exclude', 'filter', 'sort'];
}
export const listActions = {
  list: 'list',
  count: 'count',
  deleteSelected: 'deleteSelected',
  saveSelected: 'saveSelected',
  newItem: 'newItem',
  batchList: 'batchList'
};
export const listWatcherSchema = {
  title: '列表监听事件',
  type: 'object',
  fields: [{
    id: 'page',
    title: '页码改变时自动刷新数据',
    default: true
  }, {
    id: 'size',
    title: '每页数目改变时自动刷新数据',
    default: true
  }]
};
export function transformPrimitiveValue(item, target) {
  if (item.v === null) {
    // 可能要查非空，为空，这是是允许 type和value不对应的
    return;
  }
  if (target.type === 'string') {
    item.v = String(item.v);
  }
  if (target.type === 'number' || target.type === 'integer') {
    const valNumber = Number(item.v);
    item.v = Number.isNaN(valNumber) ? item.v : valNumber;
  }
  if (target.type === 'boolean' && typeof item.v !== 'boolean') {
    if (item.v === 'true') {
      item.v = true;
    }
    if (item.v === 'false') {
      item.v = false;
    }
  }
}
export function getEntityEnumArray(state) {
  try {
    const entitySchema = state.getEntitySchema();
    const paveArray = paveSchema(entitySchema);
    const enumArray = paveArray.map(item => {
      // todo 嵌套的 obj.key1 items.key2
      const id = String(item.id);
      return {
        value: id,
        label: [id, item.title ? `(${item.title})` : ''].join('')
      };
    });
    return enumArray;
  } catch (error) {
    console.error(error);
    return [];
  }
}
//# sourceMappingURL=ListState.helper.js.map
